export default "__VITE_ASSET__Dcy$l3iG__"